export enum APPOINTMENT_CHANNEL {
  PRACTO = "Practo",
  COVID_CONNECT = "Covid-Connect",
  CORPORATE_CONNECT = "Corporate-Connect",
  SPHERE_INDIA_PSYCHOLOGY = "SPPS",
  SPHERE_INDIA_COVID = "SPCO",
  TALK_TO_DOCTOR = "TTD",
  SECOND_OPINION = "SECO",
  EMERGENCY = "EMCY",
  CORPORATE_CONNECT_INIT = "CC-Init",
  WALKIN = "Walkin",
  WALKINQR = "Walkin-Scan",
  OFFLINE = "Offline",
  ON_PAD = "ON-PAD",
  UHI_HPD = "UHI_HPD",
  UHI_DCM = "UHI_DCM",
  IVR = "IVR",
  STAFF = "Staff",
  DOCTOR = "Doctor",
  FOLLOW_UP = "FOLLOW-UP",
  ONLINE_APPOINTMENT = "Online-Appointment",
  PACKAGE = "PACKAGE",
  PATIENT_REQUESTED = "Patient-Requested",
  ABHA = "ABHA",
}

export enum APPOINTMENT_STATUS {
  CANCELLED = "CN",
  ABORTED = "AB",
  NO_SHOW = "NS",
  NO_SHOW_DOCTOR = "NSD",
  NO_SHOW_STAFF = "NSS",
  COMPLETED = "CM",
  RESCHEDULED = "RE",
  ONGOING = "OG",
  BOOKED = "BK",
  PARKED = "PA",
  PROVISIONAL_CANCELLED = "PC",
  COMPLETED_NO_PRESCRIPTION = "CMNP",
  DOCTOR_RESCHEDULED = "RED",
  DOCTOR_CANCELLED = "CND",
  STAFF_RESCHEDULED = "RES",
  STAFF_CANCELLED = "CNS",
  PAYMENT_NOT_RECEIVED = "PNR",
  INITIATED = "IN",
  RESERVED = "RV",
  CHECKED_IN = "CK",
  COMPLETED_IP = "CMIP",
}

export const AppointmentEndStatus = new Set([
  APPOINTMENT_STATUS.CANCELLED,
  APPOINTMENT_STATUS.ABORTED,
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
  APPOINTMENT_STATUS.NO_SHOW_STAFF,
  APPOINTMENT_STATUS.COMPLETED,
  APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
  APPOINTMENT_STATUS.RESCHEDULED,
  APPOINTMENT_STATUS.DOCTOR_RESCHEDULED,
  APPOINTMENT_STATUS.DOCTOR_CANCELLED,
  APPOINTMENT_STATUS.STAFF_RESCHEDULED,
  APPOINTMENT_STATUS.STAFF_CANCELLED,
  APPOINTMENT_STATUS.PAYMENT_NOT_RECEIVED,
  APPOINTMENT_STATUS.PROVISIONAL_CANCELLED,
]);

export enum MODES_OF_APT {
  TELE = "tele",
  IN_CLINIC = "in_clinic",
}

export enum TYPES_OF_APT {
  REGULAR = "REG",
  FOLLOW_UP = "FLW",
}

export enum FOLLOWUP_MESSAGE_PURPOSE {
  FOLLOWUP_REMINDER = "Follow-up",
  FOLLOWUP_ACCEPTANCE_RESPONSE = "flw-yes",
  FOLLOWUP_REJECTION_RESPONSE = "flw-no",
  FOLLOWUP_RESCHEDULE_RESPONSE = "flw-res",
  FOLLOWUP_SLOT_CONFIRMATION_RESPONSE = "flw-slot-conf",
  FOLLOWUP_FEELING_BETTER_RESPONSE = "flw-feel-btr",
  FOLLOWUP_RESCHEDULE_CONFIRMATION = "flw-res-cnf",
  APPOINTMENT_REMINDER = "apt-rem",
  APPOINTMENT_REMINDER_YES_RESPONSE = "apt-rem-yes",
  APPOINTMENT_REMINDER_NO_RESPONSE = "apt-rem-no",
  APPOINTMENT_REMINDER_RESCHEDULE_RESPONSE = "apt-rem-res",
  APPOINTMENT_REMINDER_NO_LATER_DATE_RESPONSE = "apt-rem-no-later-date",
  APPOINTMENT_REMINDER_NO_FEELING_BETTER_RESPONSE = "apt-rem-no-feeling-better",
  REQUESTED_APPOINTMENT_DATE_FLEXIBLE = "req-apt-date-flexible",
}

export enum PAID_FILTER_VALUES {
  PAID = "paid",
  UNPAID = "unpaid",
}

export enum FOLLOWUP_DATE_VALUES {
  ADDED = "added",
  NOT_ADDED = "not_added",
}

export enum FOLLOWUP_STATUS_VALUES {
  ALL_FOLLOWUPS = "all_followups",
  AWAITING_RESPONSE = "awaiting_response",
  CONFIRMED_VISIT = "confirmed_visit",
  NOT_COMING = "not_coming",
}

export enum QUEUE_CONFIG_ACTION_ID {
  AVLR = "AVLR",
  ADDR = "ADDR",
  RMDR = "RMDR",
  REQP = "REQP",
  AAPT = "AAPT",
  CRMC = "CRMC",
  RTOD = "RTOD",
  SGRL = "SGRL",
  MNSH = "MNSH",
  VRCT = "VRCT",
  CATP = "CATP",
  FLWU = "FLWU",
  ABHA = "ABHA",
  UPMR = "UPMR",
}

export enum QUEUE_CONFIG_COLUMN_ID {
  TAGS = "TAGS",
  VITY = "VITY",
  PAYS = "PAYS",
  ASST = "ASST",
  PRES = "PRES",
  ABHA = "ABHA",
}

export enum ABHA_STATUS {
  NONE = "",
  PENDING = "pending",
  FAILED = "failed",
  SUCCESS = "success",
}

export enum APT_ACTIVITY {
  CREATED = "CREATED",
  VISIT_STARTED = "VISIT_STARTED",
  VISIT_ENDED = "VISIT_ENDED",
  VISIT_PARKED = "VISIT_PARKED",
  VISIT_CANCELLED = "VISIT_CANCELLED",
  VISIT_RESCHEDULED = "VISIT_RESCHEDULED",
  VISIT_CHECKED_IN = "VISIT_CHECKED_IN",
  FOLLOWUP_CHECKED_IN = "FOLLOWUP_CHECKED_IN",
  MARKED_NOSHOW = "MARKED_NOSHOW",
  MARKED_ABORTED = "MARKED_ABORTED",
  MARKED_PARKABLE = "MARKED_PARKABLE",
  MSG_SA = "MSG_SA",
  APT_REMINDER_SENT = "APT_REMINDER_SENT",
  VISIT_ARCHIVED = "VISIT_ARCHIVED",
  APT_SYNC = "APT_SYNC",
  REQ_CB = "REQ_CB",
  SA_UPDATED = "SA_UPDATED",
  APT_MUTLI_TAG = "APT_MUTLI_TAG",
  APT_TAG_ADDED = "APT_TAG_ADDED",
  APT_TAG_DELETED = "APT_TAG_DELETED",
  APT_PAYMENT_UPDATED = "APT_PAYMENT_UPDATED",
  PREPAY_FAILED = "PREPAY_FAILED",
  TELE_STATUS = "TELE_STATUS",
  FOLLOWUP_DATE_ADDED = "FOLLOWUP_DATE_ADDED",
  FOLLOWUP_MESSAGE_UPDATE = "FOLLOWUP_MESSAGE_UPDATE",
  FOLLOWUP_REMINDER_SENT = "FOLLOWUP_REMINDER_SENT",
  RESCHEDULE_CREATED = "RESCHEDULE_CREATED",
  REQUESTED_APT_CHECKED_IN = "REQUESTED_APT_CHECKED_IN",
}

export enum ACTOR_TYPE {
  DOCTOR = "DOCTOR",
  STAFF = "STAFF",
  SYSTEM = "SYSTEM",
  PATIENT = "PATIENT",
}

export const bookedAptWhitelist = new Set<string>([
  APPOINTMENT_STATUS.BOOKED,
  APPOINTMENT_STATUS.PARKED,
]);

export const completedQueueStatus = [
  APPOINTMENT_STATUS.COMPLETED,
  APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
];
export const otherQueueStatus = [
  APPOINTMENT_STATUS.CANCELLED,
  APPOINTMENT_STATUS.STAFF_CANCELLED,
  APPOINTMENT_STATUS.DOCTOR_CANCELLED,
  APPOINTMENT_STATUS.RESCHEDULED,
  APPOINTMENT_STATUS.STAFF_RESCHEDULED,
  APPOINTMENT_STATUS.DOCTOR_RESCHEDULED,
  APPOINTMENT_STATUS.ABORTED,
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
  APPOINTMENT_STATUS.NO_SHOW_STAFF,
  APPOINTMENT_STATUS.COMPLETED_IP,
];
export const followupQueueStatus = [
  APPOINTMENT_STATUS.INITIATED,
  APPOINTMENT_STATUS.RESERVED,
  APPOINTMENT_STATUS.PROVISIONAL_CANCELLED,
  // APPOINTMENT_STATUS.BOOKED,
  APPOINTMENT_STATUS.RESCHEDULED,
];

export const completedAptWhitelist = new Set<string>(completedQueueStatus);

export const followupAptWhileWhitelist = new Set<string>(followupQueueStatus);

export const otherAptWhitelist = new Set<string>(otherQueueStatus);

export const requestedAptStatusSet = new Set<string>([
  APPOINTMENT_STATUS.INITIATED,
]);

export const opdAptWhitelist = new Set<string>([
  APPOINTMENT_STATUS.CHECKED_IN,
  APPOINTMENT_STATUS.ONGOING,
]);

export const whitelistedAptStatus = new Set<string>([
  ...Array.from(completedAptWhitelist),
  ...Array.from(followupAptWhileWhitelist),
  ...Array.from(bookedAptWhitelist),
  ...Array.from(opdAptWhitelist),
  ...Array.from(otherAptWhitelist),
]);

export enum FIELD_SUB_TYPE {
  SINGLE = "single",
  MULTI = "multi",
}

export enum FIELD_TYPE {
  TEXT = "text",
  PERSON = "person",
  OPTION = "option",
}

export enum PROFILE_PERSONA {
  ADMIN = "ADMIN",
  STAFF = "STAFF",
  DOCTOR = "DOCTOR",
}

export enum SupportedTeleProviders {
  "100MS" = "100ms",
  eka = "eka",
  other = "other",
}

export const SupportedTeleProvidersLabel: Record<
  SupportedTeleProviders,
  string
> = {
  [SupportedTeleProviders.eka]: "Eka",
  [SupportedTeleProviders["100MS"]]: "100 Ms",
  [SupportedTeleProviders.other]: "Others",
};
